{
  "collapse": "收合",
  "expand": "展開"
}
